module.exports = __webpack_public_path__ + "static/media/invoice-focus.64ba119a.svg";